export default {
  sign_in: {
    title: '充电站管控运营平台',
    login: '登录',
    placeholder: {
      email: '请输入账号',
      password: '请输入密码',
      captcha: '请输入验证码'
    },
    form: {
      email: '账号',
      password: '密码',
      captcha: '验证码',
      required: '请正确填写表单！'
    },
    tips: {
      form_invalid: '请正确填写表单！'
    }
  },
  forget_password: {
    text: '忘记密码',
    remembered: '又想起了'
  },
  reset_password: {
    password: '新密码',
    checkPass: '确认密码',
    send_captcha: '发送验证码',
    resend_captcha_in: '重新发送{0}s',
    send_captcha_success: '发送验证码成功',
    success: '重置密码成功，正在跳转到登录页面',
    placeholder: {
      password: '请输入新密码',
      checkPass: '请输入确认密码'
    },
    btns: {
      reset: '确认重置'
    },
    rules: {
      password: {
        required: '请输入新密码!'
      },
      checkPass: {
        required: '请再次输入密码!',
        consistent: '两次输入密码不一致!'
      }
    }
  }
}
